import system from './system.svg'

export const getSvgNotification = (type: string) => {
    switch (type) {
        default:
            return system
    }
}
